// Copyright (c) 2020 Deere & Company

import MassUpdateRequestDetailsRoutes from './rga-mass-update-selected-rga';
import RgaMassUpdateResults from './rga-mass-update-results';

export default {
    childRoutes: [
        MassUpdateRequestDetailsRoutes,
        RgaMassUpdateResults
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/rga/results/mass-update')
    },
    name: 'Mass Update Results',
    path: 'massResults'
};




// WEBPACK FOOTER //
// ./src/routes/rga/rga-mass-update-results-routes.js